module.exports = __webpack_public_path__ + "static/media/mirrorExplore.e024b16d.png";